import React, { Component } from 'react'
import { connect } from 'react-redux'

import { closeOverlay } from '../../../actions/common'
import CloseButton from '../../elements/closeButton'

import './overlayheaderbare.scss'
import Button from '../../elements/button'
import Label from '../../elements/label'
import { translation } from '../../../utils/helpers'

class OverlayHeaderBare extends Component {
  constructor (props) {
    super(props)
    this.state = { }
  }

  componentWillUnmount () {
    if (typeof this.props.onClose === 'function') this.props.onClose()
  }

  render () {
    const renderCloseButton = () => {
      if (!this.props.closeButton) return null

      let closeButtonComp = <CloseButton onClick={() => this.props.closeOverlay(this.props.overlayId)} />

      if (this.props.custom) {
        closeButtonComp = (
          <Button size='m' spacing={0} style='link' onClick={() => this.props.closeOverlay(this.props.overlayId)}>
            <Label>{translation(16669)}</Label>
          </Button>
        )
      }

      return (
        <div className='close'>
          {closeButtonComp}
        </div>
      )
    }

    let className = `overlay-header element-overlay-top ${this.props.className || ''}`
    return (
      <div className={className}>
        {renderCloseButton()}
        {this.props.children}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

OverlayHeaderBare.defaultProps = {
  closeButton: true,
  onClose: undefined, // Callback on overlay close
  custom: false,
  label: ''
}

OverlayHeaderBare.propTypes = {
  overlayId: React.PropTypes.string.isRequired
}

export default connect(mapStateToProps, {
  closeOverlay
})(OverlayHeaderBare)



// WEBPACK FOOTER //
// ./src/app/shared/components/OverlayHeaderBare/index.js